import { render, staticRenderFns } from "./ActivityDetail.vue?vue&type=template&id=3fc29292&scoped=true"
import script from "./ActivityDetail.vue?vue&type=script&lang=ts"
export * from "./ActivityDetail.vue?vue&type=script&lang=ts"
import style0 from "./ActivityDetail.vue?vue&type=style&index=0&id=3fc29292&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc29292",
  null
  
)

export default component.exports